interface IQuoteArea {
    title: string,
    children: React.ReactNode
}

const QuoteArea = ({ title, children }: IQuoteArea) => {
    return (
        <div className="w-full">
            <p className='mb-2 tablet:mb-1 text-lg'>{title}</p>
            {children}
        </div>
    )
}

export default QuoteArea